import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/uiIssueNotificationLogsPageQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const notificationsIssueLogsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() => {
		if (!__SERVER__) {
			return import(/* webpackChunkName: "async-software-notifications-issue-logs" */ './src');
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return Promise.resolve({ default: () => null }) as unknown as Promise<{
			default: typeof import('./src').default;
		}>;
	}),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			notificationLogs: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectId: Number(context?.query?.projectId ?? 0),
					notificationType: 'INTERNAL_NOTIFICATION_ISSUE',
				},
			},
		},
		extraProps: {
			accountId: tenantContext.atlassianAccountId,
			cloudId: tenantContext.cloudId,
			projectIds: context?.query?.projectId,
			projectKey: context?.match.params.projectKey,
		},
	}),
});
